import { render, staticRenderFns } from "./EmailCompose.vue?vue&type=template&id=980aaef8"
import script from "./EmailCompose.vue?vue&type=script&lang=js"
export * from "./EmailCompose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports